import React from 'react';

import { PopupProps } from 'components/CommonPopup/types';

import * as Styles from './styles';

const CommonPopup = ({ isOpen, onClose, children }: PopupProps) => {
  if (!isOpen) return null;

  return (
    <Styles.Backdrop onClick={onClose}>
      <Styles.Container onClick={(e) => e.stopPropagation()}>
        <Styles.CloseIcon onClick={onClose} />
        <Styles.Content>{children}</Styles.Content>
      </Styles.Container>
    </Styles.Backdrop>
  );
};

export default CommonPopup;
